import { Link } from "react-router-dom";

const AREAS = [
  "Fredericksburg", "Stafford County", "Spotsylvania", "King George",
  "Culpeper", "Warrenton", "Manassas", "Woodbridge",
  "Dumfries", "Triangle", "Montross", "Orange County",
  "Rappahannock County", "Fauquier County", "Prince William County", "Madison",
];

export default function ServiceAreasSection() {
  return (
    <section className="py-24 bg-[#0f2018] relative overflow-hidden">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://public.readdy.ai/ai/img_res/0cb031b282f320fe9aa996a9c28df062.jpg"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start mb-12">
          <div>
            <span className="text-[#e8632a] font-bold text-sm uppercase tracking-[3px] block mb-4">Where We Work</span>
            <h2 className="text-4xl lg:text-5xl font-black text-white leading-tight mb-4">
              Serving Homeowners<br />
              <span className="text-[#e8632a]">Across Northern Virginia</span>
            </h2>
            <p className="text-white/60 text-base leading-relaxed mb-6">
              Based in Fredericksburg, VA — we serve a 50+ mile radius across Northern Virginia. Professional tree removal, trimming, and stump grinding wherever you are.
            </p>

            {/* City pills */}
            <div className="flex flex-wrap gap-2 mb-8">
              {AREAS.map((area) => (
                <Link
                  key={area}
                  to="/service-areas"
                  className="px-3 py-1.5 bg-white/10 text-white/80 text-xs font-semibold rounded-full border border-white/15 hover:bg-[#e8632a] hover:text-white hover:border-[#e8632a] transition-all cursor-pointer whitespace-nowrap"
                >
                  {area}
                </Link>
              ))}
            </div>

            <div className="flex items-center gap-4">
              <Link
                to="/service-areas"
                className="flex items-center gap-2 px-6 py-3 bg-[#e8632a] text-white font-black rounded-xl uppercase tracking-wide hover:bg-[#d0541e] transition-all cursor-pointer whitespace-nowrap"
              >
                View All Areas <i className="ri-arrow-right-line"></i>
              </Link>
              <a
                href="tel:+15407764488"
                className="flex items-center gap-2 text-white/60 font-bold hover:text-white cursor-pointer text-sm"
              >
                <i className="ri-phone-fill text-[#e8632a]"></i>Not sure? Call us
              </a>
            </div>
          </div>

          {/* Right: map */}
          <div>
            <div className="relative rounded-3xl overflow-hidden border-2 border-white/10 h-[420px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d198752.24834!2d-77.5982!3d38.3032!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b6c196de1e7d11%3A0x6a56c86d9c0a1b4d!2sFredericksburg%2C%20VA!5e0!3m2!1sen!2sus!4v1700000000003"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Diversified Tree Services service area Northern Virginia map"
              ></iframe>

              {/* Overlay card */}
              <div className="absolute bottom-5 left-5 bg-[#0f2018] text-white rounded-xl px-4 py-3 border border-white/10">
                <div className="flex items-center gap-2.5">
                  <i className="ri-map-pin-fill text-[#e8632a] text-xl"></i>
                  <div>
                    <p className="font-black text-sm">Fredericksburg, VA</p>
                    <p className="text-white/50 text-xs">Serving 50+ mile radius</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
